import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import ZodFieldDate from '~/components/zod/ZodFieldDate';

export default function TwtCustomerForm() {
  return (
    <FormGroup>
      <FormHorizontal name="notes" label="Notes">
        <ZodFieldTextarea name="notes" />
      </FormHorizontal>
      <FormHorizontal name="discount_photos" label="Interior/Exterior Photos Discount ($)">
        <ZodFieldInput type="number" name="discount_photos" />
      </FormHorizontal>
      <FormHorizontal name="discount_photos_pct" label="Interior/Exterior Photos Discount (%)">
        <ZodFieldInput type="number" name="discount_photos_pct" />
      </FormHorizontal>
      <FormHorizontal name="discount_photos_date" label="Interior/Exterior Photos Discount (Date)">
        <ZodFieldDate name="discount_photos_date" />
      </FormHorizontal>
      <FormHorizontal name="matterport_discount_dollars" label="Matterport Discount ($)">
        <ZodFieldInput type="number" name="matterport_discount_dollars" />
      </FormHorizontal>
      <FormHorizontal name="matterport_discount_percentage" label="Matterport Discount (%)">
        <ZodFieldInput type="number" name="matterport_discount_percentage" />
      </FormHorizontal>
      <FormHorizontal name="matterport_discount_date" label="Matterport Discount (Date)">
        <ZodFieldDate name="matterport_discount_date" />
      </FormHorizontal>
      <FormHorizontal name="discount_percentage" label="Order Discount (Excluding Twilight, %)">
        <ZodFieldInput type="number" name="discount_percentage" />
      </FormHorizontal>
      <FormHorizontal name="discount_percentage_date" label="Order Discount (Date)">
        <ZodFieldDate name="discount_percentage_date" />
      </FormHorizontal>
      <FormHorizontal name="matterport_transfer" label="Matterport Transfer">
        <ZodFieldTextarea name="matterport_transfer" />
      </FormHorizontal>
      <FormHorizontal name="matterport_camera_only" label="Matterport Camera Required">
        <ZodFieldCheckbox name="matterport_camera_only" />
      </FormHorizontal>
      <FormHorizontal name="tax_exempt" label="Tax Exempt">
        <ZodFieldCheckbox name="tax_exempt" />
      </FormHorizontal>
      <FormHorizontal name="package_jonny" label="Jonny Wells Package">
        <ZodFieldCheckbox name="package_jonny" />
      </FormHorizontal>
      <FormHorizontal name="package_justin" label="Local Life Realty Package">
        <ZodFieldCheckbox name="package_justin" />
      </FormHorizontal>
      <FormHorizontal name="package_southstone" label="Southstone Package">
        <ZodFieldCheckbox name="package_southstone" />
      </FormHorizontal>
    </FormGroup>
  );
}
